export function hoursDifferenceFromUtcNow(dateTime: Date) {
  return hoursDifference(dateTime, new Date());
}

export function hoursDifference(date1: Date, date2: Date) {
  let diff = (date2.getTime() - date1.getTime()) / 1000;
  diff /= 60 * 60;
  return Math.abs(Math.round(diff));
}
